import type { MessengerThread } from '@/api/client';

/**
 * Отображаемое число непрочитанных для пира в списке тредов — как в ChatSidebar
 * (сырой unread_count минус временное вычитание для активного чата).
 */
export function displayedMessengerUnreadForPeer(
  threads: readonly MessengerThread[],
  peerId: string,
  sidebarUnreadSubtractPeerId: string | null,
  sidebarUnreadSubtractCount: number
): number {
  const t = threads.find((th) => th.thread_kind === 'direct' && th.peer_id === peerId);
  const raw = t?.unread_count ?? 0;
  const sub =
    sidebarUnreadSubtractPeerId === peerId && sidebarUnreadSubtractCount > 0
      ? sidebarUnreadSubtractCount
      : 0;
  return Math.max(0, raw - sub);
}

/** Непрочитанные для группового треда по id (без peer_id). */
export function displayedMessengerUnreadForThread(
  threads: readonly MessengerThread[],
  threadId: string,
  sidebarUnreadSubtractThreadId: string | null,
  sidebarUnreadSubtractCount: number
): number {
  const t = threads.find((th) => th.id === threadId);
  const raw = t?.unread_count ?? 0;
  const sub =
    sidebarUnreadSubtractThreadId === threadId && sidebarUnreadSubtractCount > 0
      ? sidebarUnreadSubtractCount
      : 0;
  return Math.max(0, raw - sub);
}

/** Сумма непрочитанных по личным чатам (без групп и без «Сохранённых»). */
export function displayedMessengerUnreadTotalDirectPeers(
  threads: readonly MessengerThread[],
  sidebarUnreadSubtractPeerId: string | null,
  sidebarUnreadSubtractCount: number
): number {
  let sum = 0;
  for (const th of threads) {
    if (th.thread_kind !== 'direct' || !th.peer_id || th.is_saved) continue;
    sum += displayedMessengerUnreadForPeer(
      threads,
      th.peer_id,
      sidebarUnreadSubtractPeerId,
      sidebarUnreadSubtractCount
    );
  }
  return sum;
}

/** Сумма непрочитанных по всем групповым чатам. */
export function displayedMessengerUnreadTotalGroups(
  threads: readonly MessengerThread[],
  sidebarUnreadSubtractThreadId: string | null,
  sidebarUnreadSubtractCount: number
): number {
  let sum = 0;
  for (const th of threads) {
    if (th.thread_kind !== 'group') continue;
    sum += displayedMessengerUnreadForThread(
      threads,
      th.id,
      sidebarUnreadSubtractThreadId,
      sidebarUnreadSubtractCount
    );
  }
  return sum;
}
